import { useEffect, useState } from "react";

import { Box } from "@chakra-ui/react";
import { NOT_FOUND_INDEX, START_INDEX } from "utils/constants";

import { PAGE_ONE } from "..";
import { paginationStartStyle } from "./style";
import { IPaginationStartProps, IRowsPerPageOption } from "./types";

export const DEFAULT_ROWS_PER_PAGE_OPTIONS: IRowsPerPageOption[] = [
  {
    label: "10",
    value: 10,
  },
  {
    label: "20",
    value: 20,
  },
  {
    label: "50",
    value: 50,
  },
  {
    label: "100",
    value: 100,
  },
];

export const insertNewOptionInCorrectSortedPosition = (
  existingOptions: IRowsPerPageOption[],
  newValue: number
): IRowsPerPageOption[] => {
  const newOption: IRowsPerPageOption = {
    label: newValue.toString(),
    value: newValue,
  };

  // Find the correct index where the new item should be inserted
  const index = existingOptions.findIndex((item) => item.value > newValue);

  // If index is -1, the value is the largest, so push it at the end
  if (index === NOT_FOUND_INDEX) {
    return [...existingOptions, newOption];
  }

  // Otherwise, insert at the found index
  return [
    ...existingOptions.slice(START_INDEX, index),
    newOption,
    ...existingOptions.slice(index),
  ];
};

export const PaginationStart = (props: IPaginationStartProps) => {
  const { paginationParams, updatePaginationParams } = props;
  const { limit } = paginationParams;
  const [selectedValue, setSelectedValue] = useState<number>(limit);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState<
    IRowsPerPageOption[]
  >(DEFAULT_ROWS_PER_PAGE_OPTIONS);

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = Number(e.target.value);
    setSelectedValue(value);
    updatePaginationParams({
      page: PAGE_ONE,
      limit: value,
    });
  };

  useEffect(() => {
    const isLimitNotInCurrentOptions = rowsPerPageOptions.find(
      ({ value }) => value === limit
    );
    if (!isLimitNotInCurrentOptions) {
      const updatedRowPerPageOptions = insertNewOptionInCorrectSortedPosition(
        rowsPerPageOptions,
        limit
      );
      setRowsPerPageOptions(updatedRowPerPageOptions);
    }
  }, [limit]);

  return (
    <Box
      className="inline-flex items-center gap-3"
      css={paginationStartStyle}
    >
      <span>Rows per page</span>
      <div className="select-wrapper">
        <select
          value={selectedValue}
          onChange={handleSelect}
        >
          {rowsPerPageOptions.map((option) => (
            <option
              key={option.label}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </Box>
  );
};

export default PaginationStart;
